import { matchType } from "../base/base-type";

export type BulkDLFilesError = {
  id: string;
  target: BulkDLFilesTarget;
  message: string;
};

export type BulkDLFilesResultStatus =
  | "CONFIRM"
  | "FETCHING"
  | "ZIPPING"
  | "DONE";

export type BulkDLFilesResult = {
  status: BulkDLFilesResultStatus;
  fetchedCount: number;
  zippedPercent: number;
  errors: BulkDLFilesError[];
};

export const BulkDLFilesTargets = ["ATTACHED", "PDF"] as const;
export type BulkDLFilesTarget = (typeof BulkDLFilesTargets)[number];

export const BulkDLFilesTargetLabel = (target: BulkDLFilesTarget) => {
  return matchType(target, {
    ATTACHED: "添付ファイル",
    PDF: "帳票ファイル",
  });
};
